import utils from './utils'
import store from './../store'

export default {
	data() {
		return {
			classColor: {
				ok: 'green',
				warning: 'orange',
				alert: 'red',
				deactivated: 'grey',

				other: 'red',
				unknown: 'blue',
				no_modules: 'gray',
				no_hubs: 'gray',
				no_locations: 'gray',
			},
		}
	},
	computed: {
		userTheme: () => store.state.userTheme,
		user: () => store.state.user,
		isAdmin: () => ['admin', 'developer'].includes(store.state.user?.role),
		isDev: () => ['developer'].includes(store.state.user?.role),
		projectsObj: () => store.getters.projectsObj,
		version: () => store.state.version,
		locationIdRoute: () => store.state.locationIdRoute || '',
		modulIdRoute: () => store.state.modulIdRoute || '',
		hubIdRoute: () => store.state.hubIdRoute || '',
		projectIdRoute: () => store.state.projectIdRoute || '',
		projectIdCalculated: () => store.state.projectIdCalculated || '',
		comappIdRoute: () => store.state.comappIdRoute || '',
		sc: () => store.state.sc || 1,

		// locationIdRoute: () => (router.currentRoute as any)._value.params.locationId || ""

		// get locationId() {
		//   return this.$route.params.locationId || "";
		// }
	},
	methods: {
		...utils,

		toggleTheme() {
			// const userTheme =
			// 	this.userTheme === "norddark" ? "light" : "norddark"
			// this._set([ "userTheme", userTheme ])
		},

		statusLightClass(status: any) {
			return {
				_green: status == 'ok',
				_redBlink: status == 'alert',
				_orange: status == 'warning',

				_white: !status || status == 'unknown',
				_black: status == 'deactivated',
				// _red: status == 'alert',
				// _blue: status == 'no_locations',
				_greym: status == 'no_modules',
				_greyl: status == 'no_hubs',
				_greyd: status == 'no_locations',
			}
		},

		map_markers(locations: any, proLocId: string = '') {
			// console.log(this.locations);
			// return this.locations.map((el: any) => ({
			if (proLocId) locations = locations.filter((el: any) => el.projectId === proLocId || el._id === proLocId)

			return locations.map((el: any) => ({
				color: el.color || '#00876c',
				// status: el.alertInterval || "alarm",
				// status: el.status || "unknown",
				status: this.allStates.locations[el._id] || 'unknown',
				state: this.allStates.locations[el._id] || 'unknown',

				// color: "#00876c",
				lat: parseFloat(el.lat) || 48.20238413054293,
				lng: parseFloat(el.lng) || 16.347148330686213,
				title: el.name,
				content: this.map_markerText(el),
			}))
		},

		map_markerText(el: any) {
			return `<div>
      <b><a href="/location/${el._id}">${el.name}</a> </b>
      <br>
      status: ${el.state} 
      <br>
      <br>
      Project <a href="/projects/${el.projectId}">${this.projectsObj[el.projectId]?.name}</a>
      </div>`
		},

		mapBoxMarker(locations: any, proLocId: string = '') {
			if (proLocId) locations = locations.filter((el: any) => el.projectId === proLocId || el._id === proLocId)
			return locations.map((el: any) => ({
				type: 'Feature',
				geometry: {
					type: 'Point',
					coordinates: [parseFloat(el.lng) || 16.347148330686213, parseFloat(el.lat) || 48.20238413054293],
				},
				// icon: {
				//   'marker-color': '#ff8888',
				//   'marker-size': 'large'
				// },
				properties: {
					title: el.name,
					description: '',
					// status: this.allStates.locations[el._id] || "unknown",
					state: this.allStates?.locations?.[el._id] || 'unknown',
					status: el.state || 'unknown',
					content: this.mapBoxMarkerText(el),
				},
			}))
		},

		mapBoxMarkerText(el: any) {
			const state = this.allStates?.locations?.[el._id]
			return `<div class="colGray">
        <b><a href="/location/${el._id}" class="pcLink">${el.name}</a></b><br>
        State: ${state} <br>
        <a href="/projects/${el.projectId}" class="pcLink">${this.projectsObj[el.projectId]?.name}</a>
        </div>`
		},
	},
}

// ? possible status: ok / alert / unknown / deactivated / other
